<template>
    <div class="message">
        <p class="text">{{ message }}</p>
    </div>
</template>

<script>
    export default {
        name: "LiveChatMessage",
        props: {
            message: {
                type: String,
                required: true
            }
        }
    }
</script>

<style scoped>
    .message {
        width: 65%;
        margin-top: 10px;
        border-radius: 10px;
        padding: 10px;
        font-size: 1rem;
    }

    .message.support {
        align-self: flex-start;
        background-color: #9bfffd;
    }

    .message.client {
        align-self: flex-end;
        background-color: #fdffa7;
    }

    .message .text {
        margin: 0;
        word-wrap: break-word;
    }
</style>